function fireConversion(label) {
  if (typeof gtag === 'function') {
    gtag('event', 'conversion', {
      'send_to': 'AW-979159260/' + label
    });
  }
}

function fireGA4Event(eventName) {
  if (typeof gtag === 'function') {
    gtag('event', eventName, {
      'send_to': 'G-XLM58L3KFJ'
    });
  }
}

// --- Succes "Cere ofertă" prin redirect ---
if (window.location.search.includes('contact_posted=true')) {
  fireConversion('NCeRCMDk0eAcENyR89ID');
  fireGA4Event('cere_oferta_submit');

  var params = new URLSearchParams(window.location.search);
  params.delete('contact_posted');
  var newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash;
  history.replaceState({}, '', newUrl);
}

// --- Click pe telefon ---
document.addEventListener('click', function (e) {
  var telLink = e.target.closest('a[href^="tel:"]');
  if (telLink) {
    fireConversion('y-GcCLzpwOAcENyR89ID');
    fireGA4Event('click_telefon');
  }
});